// Per-language starter snippets — each shows hello + a streaming demo where useful.
// Phase 2 displays these the first time a user picks a language; subsequent
// switches load the per-language localStorage scratch (see App.js).
const SAMPLES = {
  python: `# Python — try Run (Cmd/Ctrl+Enter)
import time

for i in range(5):
    print(f"tick {i}", flush=True)
    time.sleep(1)

print("hello from python")
`,
  javascript: `// JavaScript (Node)
for (let i = 0; i < 5; i++) {
  console.log('tick', i);
  require('child_process').execSync('sleep 1');
}
console.log('hello from node');
`,
  typescript: `// TypeScript via tsx
const greet = (name: string): string => \`hello from \${name}\`;

for (let i = 0; i < 3; i++) {
  console.log('tick', i);
}
console.log(greet('typescript'));
`,
  php: `<?php
for ($i = 0; $i < 3; $i++) {
    echo "tick $i\n";
}
echo "hello from php\n";
`,
  bash: `#!/usr/bin/env bash
for i in 1 2 3; do
  echo "tick $i"
  sleep 1
done
echo "hello from bash"
`,
  ruby: `# Ruby
3.times do |i|
  puts "tick #{i}"
end
puts 'hello from ruby'
`,
  perl: `# Perl
for my $i (0..2) {
    print "tick $i\n";
}
print "hello from perl\n";
`,
  lua: `-- Lua
for i = 0, 2 do
    print("tick " .. i)
end
print("hello from lua")
`,
  go: `package main

import (
    "fmt"
    "time"
)

func main() {
    for i := 0; i < 3; i++ {
        fmt.Println("tick", i)
        time.Sleep(time.Second)
    }
    fmt.Println("hello from go")
}
`,
  java: `public class Main {
    public static void main(String[] args) throws Exception {
        for (int i = 0; i < 3; i++) {
            System.out.println("tick " + i);
            Thread.sleep(1000);
        }
        System.out.println("hello from java");
    }
}
`,
  c: `#include <stdio.h>
#include <unistd.h>

int main(void) {
    for (int i = 0; i < 3; i++) {
        printf("tick %d\n", i);
        fflush(stdout);
        sleep(1);
    }
    printf("hello from c\n");
    return 0;
}
`,
  cpp: `#include <iostream>
#include <unistd.h>

int main() {
    for (int i = 0; i < 3; i++) {
        std::cout << "tick " << i << std::endl;
        sleep(1);
    }
    std::cout << "hello from c++" << std::endl;
    return 0;
}
`,
  rust: `fn main() {
    for i in 0..3 {
        println!("tick {}", i);
    }
    println!("hello from rust");
}
`,
  csharp: `using System;
class M {
    static void Main() {
        for (int i = 0; i < 3; i++) Console.WriteLine($"tick {i}");
        Console.WriteLine("hello from c#");
    }
}
`,
  kotlin: `fun main() {
    for (i in 0..2) println("tick $i")
    println("hello from kotlin")
}
`,
  swift: `for i in 0..<3 { print("tick \\(i)") }
print("hello from swift")
`,
  r: `for (i in 0:2) cat(sprintf("tick %d\n", i))
cat("hello from r\n")
`,
  dart: `void main() {
  for (var i = 0; i < 3; i++) print('tick $i');
  print('hello from dart');
}
`,
  sql: `-- sqlite3 (in-memory)
CREATE TABLE greetings (id INTEGER, msg TEXT);
INSERT INTO greetings VALUES
    (1, 'hello from sqlite'),
    (2, 'phase 2 ide is live');
SELECT id || ' | ' || msg AS line FROM greetings;
`,
  html: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>NoEffortsAi iDE preview</title>
    <style>
      body { font-family: system-ui, sans-serif; padding: 32px; background:#0a0d18; color:#e6ecff; }
      h1 { color:#56d6a3; }
      button { padding: 8px 14px; border-radius: 8px; border: 1px solid #2a3450;
               background: #161c2c; color: inherit; cursor: pointer; }
      button:hover { border-color: #6e8bff; }
    </style>
  </head>
  <body>
    <h1>hello from html</h1>
    <p>Click the button to see the JS run inside the iframe sandbox.</p>
    <button id="btn">say hi</button>
    <p id="out"></p>
    <script>
      document.getElementById('btn').onclick = () => {
        document.getElementById('out').textContent =
          'It is ' + new Date().toLocaleTimeString();
      };
    </script>
  </body>
</html>
`,
};

export default SAMPLES;
